<h1 mat-dialog-title>{{message}}</h1>
<div mat-dialog-actions align="center">
  <button mat-raised-button class="yes-button" [mat-dialog-close]="true">Da</button>
  <button mat-raised-button class="no-button" (click)="onNoClick()" cdkFocusInitial>Nu</button>
</div>